// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main." + {"785":"44c03e1a36fbdcdc8d49","823":"11c431d6b1afca77f6c1"}[chunkId] + ".css";
};